import {create} from '@wix/fedops-logger';
import {factory} from '@wix/web-bi-logger/dist/src/logger';
import {isBlacklisted} from '../utils/isBlacklisted';

export enum Interactions {
  LoadExternalData = 'load-External-Data',
}

export enum LoadingPhases {
  DataRetrieval = 'data-retrieval',
  StylesAdded = 'styles-added',
  AppMounted = 'app-mounted',
  PlayerInit = 'player-init',
}

const sentPhases = new Set();

const biLoggerFactory = factory().setMuted(isBlacklisted());

export const fedopsLogger = create(window.__FEDOPS_APP_NAME__ || 'music-widget', {
  biLoggerFactory,
} as any); // TODO: Remove when new logger released

export const appLoadingPhaseStart = (phase: LoadingPhases) => {
  if (sentPhases.has(phase)) {
    return;
  }
  fedopsLogger.appLoadingPhaseStart(phase);
  sentPhases.add(phase);
};
